const Input = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  required = false,
  className = "",
  name,
  checked,
  width,
  disabled = false,
}) => {
  return (
    <div className={`flex flex-col ${className}`}>
      <label className="mb-3 text-left font-outfit text-[14px] font-medium leading-[17.64px] text-[#666666]">
        {label}
      </label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        name={name}
        checked={checked}
        disabled={disabled}
        className={`${width} rounded-[10px] border border-gray-300 p-2 focus:border-blue-500 focus:outline-none`}
      />
    </div>
  );
};

export default Input;
